import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice d'énergie électrique";
const DESCRIPTION =
  "Calculatrice d'énergie électrique. Calculateur de physique en francais avec resultat rapide, unites claires et aide pratique pour exercices et revisions.";
const KEYWORDS =
  "electrical energy calculator, calculatrice physique, formule physique, exercices de physique, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/electrical-energy-calculator/";
function ElectricalEnergyCalculator() {
  const [power, setPower] = useState("");
  const [time, setTime] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!power || !time) {
        setError("Veuillez entrer puissance et temps");
        setResult(null);
        return;
      }
      const p = parseFloat(power);
      const t = parseFloat(time);
      if (p <= 0 || t <= 0) {
        setError("Les valeurs doivent être positives");
        setResult(null);
        return;
      }
      const energy = (p * t) / 1000;
      setResult(energy.toFixed(3));
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice d'énergie électrique calcule la consommation énergétique.
                  Formule: E = P × t ÷ 1000 (en kWh), où P est la puissance en watts
                  et t est le temps en heures.
                </p>
                <ul>
                  <li>Calcul de consommation électrique</li>
                  <li>Résultats en kilowatts-heure (kWh)</li>
                  <li>Utile pour les factures d'électricité</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Puissance (watts)
                      </label>
                      <input
                        type="number"
                        value={power}
                        onChange={(e) => setPower(e.target.value)}
                        placeholder="Entrez la puissance"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Temps (heures)
                      </label>
                      <input
                        type="number"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        placeholder="Entrez le temps"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>
                        Énergie consommée = <strong>{result} kWh</strong>
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
    </div>
  );
}
export default ElectricalEnergyCalculator;
